import $ from 'jquery';
import 'select2/dist/js/select2';
import './css/multimediaPage.scss';

import flatpickr from "flatpickr";
import spanishFlatpickr from 'flatpickr/dist/l10n/es'
import {infiniteScrollDetect} from "../modulos/infiniteScrolling/detectAndLoadInfiniteScrolling";


export const multimediaPage = () => {
    //Scrolls infinitos
    infiniteScrollDetect();

    const dateIniInput = document.querySelector('#MultimediaSearch_fromDate');
    const dateEndInput = document.querySelector('#MultimediaSearch_toDate');
    flatpickr(dateIniInput, {locale: spanishFlatpickr});
    flatpickr(dateEndInput, {locale: spanishFlatpickr});

    $(function(){
        $('#MultimediaSearch_idSource').select2({
            allowClear : true,
            language: {
                noResults: function() { return "No hay resultados con ese criterio"; }
            },
            placeholder: 'Buscar por fuente',
            escapeMarkup: function (markup) { return markup; }, // let our custom formatter work
            templateResult: function(repo){
                const matches = repo.text.match(/\((.*)\)/);
                if (matches === null) {
                    return '<div class="select2-result-repository select2-search select2-favorite-result clearfix">' +
                        '<div class="name">' + repo.text + '</div>' +
                        '</div>';
                }

                return '<div class="select2-result-repository select2-search select2-favorite-result clearfix">' +
                    '<div class="name">' + repo.text.replace('(' + matches[1] + ')', '') + '<span class="entities">' + matches[1].charAt(0).toUpperCase() + matches[1].slice(1) + '</span></div>' +
                    '</div>';
            },
            templateSelection: function(repo){
                const matches = repo.text.match(/\((.*)\)/);
                if (matches === null) {
                    return repo.text;
                }

                return repo.text.replace('(' + matches[1] + ')', '');
            }
        });

        const idTickerSelect = $('#MultimediaSearch_idTicker');
        idTickerSelect.select2({
            allowClear : true,
            minimumInputLength: 2,
            dropdownAutoWidth: true,
            placeholder: 'Buscar por valor',
            ajax: {
                url: function (params) { return unmaskpath(idTickerSelect.data('tickersearcher'));},
                data: function (params) { return { 'term': params.term }; },
                processResults: function (data) {return { results: data.data }; }
            },
            language: {
                inputTooShort: function(args) {return "Inserte al menos 2 caracteres";},
                errorLoading: function() {return "No se pudieron cargar los resultados";},
                loadingMore: function() {return "Cargando más resultados";},
                noResults: function() {return "No hay resultados con ese criterio";},
                searching: function() {return "Buscando...";},
                maximumSelected: function(args) {return "No se pueden mostrar los resultados";}
            },
            escapeMarkup: function (markup) { return markup; }, // let our custom formatter work
            templateResult: function(repo){
                if (repo.loading) {
                    return repo.text;
                }
                let type = '';
                switch(repo.type){
                    case 0: case "0": type='Acción';break;
                    case 2: case "2": type='Forex';break;
                    case 4: case "4": type='Índice';break;
                    case 13: case "13": type='Sicav';break;
                }

                return '<div class="select2-result-repository select2-search select2-favorite-result clearfix">' +
                    '<div class="name">'+repo.name+'<span class="ticker">'+repo.ticker+'</span></div>' +
                    '<div class="other"><div class="mic">'+repo.mic+'</div>' +
                    '<div class="type">'+type+'</div></div>' +
                    '</div>';
            },
            templateSelection: function(repo){
                if (repo.name) {
                    return repo.name;
                }

                return repo.text;
            }
        });
    });
}